/* Era Organics — PDP v2 behaviour. Vanilla JS, no jQuery, no dependence on the old theme's custom scripts.
   Works alongside Dawn's <product-form> (add to cart) and the Recharge + Kaching app blocks.
   Kaching has no selection event/API, so the offer box watches the DOM (MutationObserver) for --selected changes. */
(function () {
  'use strict';

  /* ---------- FAQ + top accordions: one open at a time (opening one closes the others in the same list) ---------- */
  // 'toggle' doesn't bubble, so listen in the capture phase. More about / Popular searches are single panels, not grouped.
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || d.tagName !== 'DETAILS' || !d.open) return;
    var list = d.parentElement;
    if (!list || !list.closest('.pdp-v2') || !list.matches('.v2-faq, .v2-objections')) return;
    Array.prototype.forEach.call(list.children, function (o) { if (o !== d && o.tagName === 'DETAILS' && o.open) o.open = false; });
  }, true);

  var root = document.querySelector('[data-v2-root]');
  if (!root) return;
  var page = root.closest('.pdp-v2');

  function readJSON(sel) { var el = page.querySelector(sel); try { return el ? JSON.parse(el.textContent) : null; } catch (e) { return null; } }
  var variants = readJSON('[data-v2-variants]') || [];
  var cfg = readJSON('[data-v2-config]') || {};
  var fmt;
  try { fmt = new Intl.NumberFormat(cfg.locale || 'en', { style: 'currency', currency: cfg.currency || 'USD' }); } catch (e) { fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
  function money(cents) { return fmt.format(cents / 100); }
  function parseMoney(text) {
    if (!text) return null;
    var n = String(text).replace(/[^0-9.,]/g, '');
    if (/,\d{2}$/.test(n) && n.indexOf('.') === -1) n = n.replace(/\./g, '').replace(',', '.'); else n = n.replace(/,/g, '');
    var v = parseFloat(n);
    return isNaN(v) ? null : Math.round(v * 100);
  }

  /* ---------- ✓ line: when it wraps on desktop, drop the "·" separator at the start of each new line ---------- */
  (function () {
    var list = page.querySelector('[data-v2-checks]');
    if (!list) return;
    function mark() {
      var items = list.querySelectorAll('.v2-check'), top = null;
      for (var i = 0; i < items.length; i++) items[i].classList.remove('v2-row-start');
      for (var j = 0; j < items.length; j++) {
        var t = items[j].offsetTop;
        if (j > 0 && t > top + 2) items[j].classList.add('v2-row-start');
        top = t;
      }
    }
    mark();
    window.addEventListener('resize', mark);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(mark);
  })();

  /* ---------- smooth scroll for in-page links (#reviews, #v2-buy) ---------- */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[data-v2-scroll]');
    if (!a) return;
    var target = document.querySelector(a.getAttribute('href'));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  /* ---------- Judge.me reviews (judgeme-widget-r2, Oct 23): 6 cards first. Judge.me always loads 15 and shows no
     "Show more" when a product has 15 or fewer, so the first "Show more" is ours (it opens the rest Judge.me has
     loaded); after that Judge.me's own button loads 15 more each press. Without this script every loaded card shows. ---------- */
  var jmBox = document.querySelector('.pdp-v2 .v2-reviews-widget');
  if (jmBox && window.MutationObserver) {
    var jmOpen = false;
    var jmMore = document.createElement('button');
    jmMore.type = 'button';
    jmMore.className = 'v2-jm-more';
    jmMore.textContent = 'Show more';
    jmMore.hidden = true;
    var jmSync = function () {
      var n = jmBox.querySelectorAll('.jdgm-masonry-grid__masonry-item').length;
      var limit = !jmOpen && n > 6;
      if (limit) jmBox.setAttribute('data-v2-jm-limit', ''); else jmBox.removeAttribute('data-v2-jm-limit');
      jmMore.hidden = !limit;
      if (n && !jmMore.isConnected) jmBox.appendChild(jmMore);
    };
    jmMore.addEventListener('click', function () { jmOpen = true; jmSync(); });
    new MutationObserver(function () { window.requestAnimationFrame(jmSync); }).observe(jmBox, { childList: true, subtree: true });
    jmSync();
  }

  /* ---------- description Read more: drop it when the text already fits in ~4 lines ---------- */
  var desc = page.querySelector('[data-v2-desc]');
  if (desc) {
    var dBody = desc.querySelector('.v2-desc-body');
    if (dBody && dBody.scrollHeight <= dBody.clientHeight + 2) desc.classList.add('v2-desc-fits');
  }

  /* ---------- tabs (#benefits, #description, #how-to-use) ---------- */
  var tabWrap = page.querySelector('[data-v2-tabs]');
  if (tabWrap) {
    var tabs = Array.prototype.slice.call(tabWrap.querySelectorAll('[role="tab"]'));
    // Default state (Benefits open, or Description & FAQ when there's no Benefits tab) is rendered in the HTML; only
    // switch for a real tab id, so other hashes (#reviews, #faq…) leave the current tab untouched.
    var show = function (id, focus) {
      if (!tabs.some(function (t) { return t.dataset.tab === id; })) return false;
      tabs.forEach(function (t) {
        var on = t.dataset.tab === id;
        t.setAttribute('aria-selected', on); t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.dataset.tab); if (p) p.hidden = !on;
        if (on && focus) t.focus();
      });
      return true;
    };
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) { e.preventDefault(); show(t.dataset.tab); history.replaceState(history.state, '', '#' + t.dataset.tab); });
      t.addEventListener('keydown', function (e) {
        var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!d) return; e.preventDefault();
        show(tabs[(i + d + tabs.length) % tabs.length].dataset.tab, true);
      });
    });
    var openFromHash = function () {
      var h = location.hash.replace('#', '');
      if (h && show(h)) tabWrap.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
    document.addEventListener('click', function (e) {   // any link to #benefits etc. elsewhere on the page
      var a = e.target.closest('a[href^="#"]'); if (!a || a.closest('[data-v2-tabs]')) return;
      var id = a.getAttribute('href').slice(1);
      if (tabs.some(function (t) { return t.dataset.tab === id; })) { e.preventDefault(); show(id); tabWrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  }

  /* ---------- whole left column sticky: top = min(76, viewport − column − 16) ---------- */
  var col = page.querySelector('[data-v2-sticky-col]');
  function setTop() {
    if (!col) return;
    if (window.innerWidth < 880) { col.style.top = ''; return; }
    col.style.top = Math.min(76, window.innerHeight - col.offsetHeight - 16) + 'px';
  }
  setTop();
  window.addEventListener('resize', setTop);
  window.addEventListener('load', setTop);
  if (col && 'ResizeObserver' in window) new ResizeObserver(setTop).observe(col);

  /* ---------- gallery: scroll-snap track (swipe is native) + arrows, arrow keys, dots, thumbnails ---------- */
  var track = page.querySelector('[data-v2-track]');
  var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-v2-slide]')) : [];
  var thumbs = Array.prototype.slice.call(page.querySelectorAll('[data-v2-thumb]'));
  var dots = Array.prototype.slice.call(page.querySelectorAll('[data-v2-dots] .v2-gal-dot'));
  var prevBtn = page.querySelector('[data-v2-prev]'), nextBtn = page.querySelector('[data-v2-next]');
  var galIndex = -1;
  var smooth = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  function goTo(i, instant) {
    if (!track || !slides.length) return;
    if (i !== galIndex && galIndex > -1) loadDeferred();
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: instant || !smooth ? 'auto' : 'smooth' });
    setIndex(i);
  }
  function setIndex(i) {
    if (i === galIndex) return;
    galIndex = i;
    var id = slides[i] && slides[i].dataset.mediaId;
    thumbs.forEach(function (t) { t.setAttribute('aria-current', t.dataset.mediaId === id ? 'true' : 'false'); });
    dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    if (prevBtn) prevBtn.disabled = i === 0;
    if (nextBtn) nextBtn.disabled = i === slides.length - 1;
  }
  function showMedia(btn) {   // thumbnail click + variant change
    if (!btn) return;
    var i = slides.findIndex(function (s) { return s.dataset.mediaId === btn.dataset.mediaId; });
    if (i > -1) goTo(i);
  }
  // deferred slides (see pdp-v2-main): load once the first image is in, after a short idle, or on first touch
  var deferred = track ? Array.prototype.slice.call(track.querySelectorAll('img[data-v2-deferred]')) : [];
  function loadDeferred() {
    if (!deferred || !deferred.length) return;
    deferred.forEach(function (img) {
      if (img.dataset.v2Srcset) img.srcset = img.dataset.v2Srcset;
      if (img.dataset.v2Src) img.src = img.dataset.v2Src;
      img.removeAttribute('data-v2-deferred');
    });
    deferred = [];
  }
  if (deferred.length) {
    var firstImg = track.querySelector('[data-v2-slide] img:not([data-v2-deferred])');   // Shopify's image_tag drops custom data- attributes
    var later = function () { setTimeout(function () { (window.requestIdleCallback || setTimeout)(loadDeferred, { timeout: 1500 }); }, 300); };
    if (!firstImg || firstImg.complete) later(); else { firstImg.addEventListener('load', later, { once: true }); firstImg.addEventListener('error', later, { once: true }); }
    ['touchstart', 'pointerdown', 'focusin', 'scroll'].forEach(function (ev) { track.addEventListener(ev, loadDeferred, { once: true, passive: true }); });
    thumbs.concat([prevBtn, nextBtn]).forEach(function (el) { if (el) el.addEventListener('pointerdown', loadDeferred, { once: true, passive: true }); });
  }
  if (track && slides.length) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; setIndex(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); });
    }, { passive: true });
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(galIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(galIndex + 1); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); goTo(galIndex + (e.key === 'ArrowRight' ? 1 : -1)); }
      else if (e.key === 'Home' || e.key === 'End') { e.preventDefault(); goTo(e.key === 'Home' ? 0 : slides.length - 1); }
    });
    // start on the selected variant's image (the server marks the current thumb)
    var cur = thumbs.find(function (t) { return t.getAttribute('aria-current') === 'true'; });
    var start = cur ? slides.findIndex(function (s) { return s.dataset.mediaId === cur.dataset.mediaId; }) : 0;
    goTo(start > 0 ? start : 0, true);
    window.addEventListener('resize', function () { goTo(galIndex, true); });   // keep the same image after rotate/resize
  }
  thumbs.forEach(function (t) { t.addEventListener('click', function () { showMedia(t); }); });

  /* ---------- variant pills ---------- */
  var form = document.getElementById('product-form-' + root.dataset.section);
  var idInput = form && form.querySelector('input[name="id"]');
  var atc = page.querySelector('[data-v2-atc]');
  var atcLabel = page.querySelector('[data-v2-atc-label]');
  var soldOutEls = page.querySelectorAll('.v2-buy, [data-v2-sticky-atc]');   // .is-sold-out: CSS hides the offer box, app widgets + sticky bar
  var currentVariant = variants.find(function (v) { return idInput && String(v.id) === idInput.value; }) || variants[0];
  var fieldsets = Array.prototype.slice.call(page.querySelectorAll('[data-v2-option]'));
  fieldsets.forEach(function (fs) {
    fs.addEventListener('change', function () {
      var opts = fieldsets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) return;
      currentVariant = v;
      if (idInput) { idInput.value = v.id; idInput.disabled = !v.available; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
      if (atc) { if (v.available) { atc.removeAttribute('disabled'); atc.removeAttribute('aria-disabled'); } else atc.setAttribute('disabled', 'disabled'); }
      var u = new URL(location.href); u.searchParams.set('variant', v.id);
      history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      if (v.media) showMedia(thumbs.find(function (t) { return t.dataset.mediaId === String(v.media); }));
      if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.variantChange, { data: { sectionId: root.dataset.section, html: document, variant: v } }); } catch (e) {} }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: v } }));
      render();
    });
  });
  // Default size (Oct 27): the server started on the section's "Default size" instead of Shopify's first variant, but
  // the app blocks were drawn for the first variant. Tell them the same way a size click does: now, and again as each app goes live.
  var defaultId = root.getAttribute('data-v2-default-variant');
  function announceDefault() {
    if (!defaultId || !idInput || idInput.value !== defaultId) return;   // stops once the shopper picks another size
    idInput.dispatchEvent(new Event('change', { bubbles: true }));
    if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.variantChange, { data: { sectionId: root.dataset.section, html: document, variant: currentVariant } }); } catch (e) {} }
    document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: currentVariant } }));
  }
  announceDefault();

  /* ---------- offer box: Recharge subscribe card + Kaching packs act as ONE pick ----------
     No discount stacking: Subscribe → Recharge subscription + Kaching forced to Single (no card shown selected).
     Any Kaching card → Recharge one-time.
     Instant buy box: the section draws static cards (snippets/pdp-v2-static-offers) with the first paint and lays each
     app out invisibly on top of the box. The pick lives here (mode + bar); each app is given it as soon as it's ready,
     and once BOTH are ready the static cards are swapped for them in one frame (.v2-live-rc / .v2-live-k, no paint in
     between). After APP_TIMEOUT the static cards carry on alone (Subscribe/Single through Shopify's selling plans,
     packs disabled if Kaching is missing) and each app is swapped in whenever it does turn up, keeping the pick. */
  var box = page.querySelector('[data-v2-offerbox]');
  var onceTotal = box && box.querySelector('[data-v2-once-total]');
  var mode = box ? box.dataset.mode || '' : '';   // 'sub' | 'once' | '' (no apps)
  var bar = 0;                // picked Kaching bar while mode is 'once' and Kaching isn't live (0 Single, 1 3 Pack, 2 5 Pack, 3 set)
  var internal = 0;           // >0 while we click app controls ourselves
  var dealQty = null;         // [qty per bar] from Kaching's deal data (for per-item pricing)
  var dealBars = null;        // that deal's bars (discount per bar)
  var scRc = box && box.querySelector('[data-v2-static="rc"]');
  var scK = box && box.querySelector('[data-v2-static="k"]');
  var hasStatic = !!(scRc || scK);
  var defaultApplied = hasStatic;   // static cards already show the default pick
  var APP_TIMEOUT = 8000;           // ms from navigation start
  var timedOut = false;
  window.__v2swap = [];             // swap log, read by scripts/buybox-tests.mjs

  function rcSubLabel() { return box && box.querySelector('.rc-radio.subscription-radio'); }
  function rcOneLabel() { return box && box.querySelector('.rc-radio.onetime-radio'); }
  function kBars() { return box ? Array.prototype.slice.call(box.querySelectorAll('.kaching-bundles__bar')) : []; }
  function kSelected() { return box && box.querySelector('.kaching-bundles__bar--selected'); }
  function clickQuiet(el) { if (!el) return; internal++; try { el.click(); } finally { setTimeout(function () { internal--; }, 0); } }
  function rcIsSub() { var l = rcSubLabel(); return !!(l && l.classList.contains('rc-radio--active')); }
  function isLive(app) { return !!box && box.classList.contains(app === 'rc' ? 'v2-live-rc' : 'v2-live-k'); }
  function scRadios() { return box ? Array.prototype.slice.call(box.querySelectorAll('.v2-sc-radio')) : []; }
  function scRadio(i) { return scK && scK.querySelector('.v2-sc-radio[data-bar="' + i + '"]'); }
  function curBar() { return isLive('k') ? Math.max(0, kBars().indexOf(kSelected())) : bar; }
  // ready = rendered, and (Kaching) its skin CSS has applied and the deal data is known, so the swap changes nothing visible
  // (Recharge renders its frequency dropdown only while Subscribe is active, so that is checked in appsMatch, not here)
  function rcReady() {
    if (!(rcSubLabel() && rcOneLabel())) return false;
    var css = box.querySelector('link[data-v2-rc-css]');   // Recharge's stylesheet, loaded non-blocking by the section
    return !css || css.media === 'all';
  }
  function kReady() {
    var n = kBars().length;
    if (!n || !dealBars) return false;
    if (scK && n < scK.querySelectorAll('.v2-sc-radio[data-bar]').length) return false;
    return getComputedStyle(box).getPropertyValue('--v2-kskin').trim() === '1';
  }

  function selectSub() {
    mode = 'sub';
    var l = rcSubLabel();
    if (l && !rcIsSub()) clickQuiet(l.querySelector('input') || l);
    var first = kBars()[0];
    if (first && !first.classList.contains('kaching-bundles__bar--selected')) clickQuiet(first.querySelector('label') || first);
    render();
  }
  function selectOnce() {
    mode = 'once';
    var l = rcOneLabel();
    if (l && rcIsSub()) clickQuiet(l.querySelector('input') || l);
    render();
  }
  // Give an app the current pick (idempotent: only clicks what differs)
  function syncRc() {
    if (!rcReady()) return;
    var want = mode === 'sub';
    if (rcIsSub() !== want) { var l = want ? rcSubLabel() : rcOneLabel(); if (l) clickQuiet(l.querySelector('input') || l); }
    var mine = scRc && scRc.querySelector('[data-v2-sc-plan]'), theirs = box.querySelector('.rc-selling-plans select');
    if (want && mine && theirs && theirs.value !== mine.value && Array.prototype.some.call(theirs.options, function (o) { return o.value === mine.value; })) {
      internal++; theirs.value = mine.value; theirs.dispatchEvent(new Event('change', { bubbles: true })); setTimeout(function () { internal--; }, 0);
    }
  }
  function syncK() {
    if (!kBars().length) return;
    var b = kBars()[mode === 'sub' ? 0 : bar];
    if (b && !b.classList.contains('kaching-bundles__bar--selected')) clickQuiet(b.querySelector('label') || b);
  }
  function appsMatch(rc, k) {
    if (rc && rcIsSub() !== (mode === 'sub')) return false;
    if (rc && mode === 'sub' && !box.querySelector('.rc-selling-plans select')) return false;
    if (rc && box.dataset.subNote && !box.querySelector('.rc-radio .v2-rc-note')) return false;   // our extra line is back after a Recharge re-render
    if (k && kBars().indexOf(kSelected()) !== (mode === 'sub' ? 0 : bar)) return false;
    return true;
  }

  function barTotal(bar) {
    if (!bar) return null;
    var priceEl = bar.querySelector('.kaching-bundles__bar-price');
    if (!priceEl) return null;
    var unit = priceEl.querySelector('.kaching-bundles__bar-price__unit-label');
    var txt = Array.prototype.filter.call(priceEl.childNodes, function (n) { return n.nodeType === 3; }).map(function (n) { return n.textContent; }).join('') || priceEl.textContent;
    var cents = parseMoney(txt);
    if (cents == null) return null;
    if (unit) {   // deal has "Show prices per item" ON → multiply by the pack size
      var i = kBars().indexOf(bar), q = dealQty && dealQty[i];
      if (!q) { var m = (bar.querySelector('.kaching-bundles__bar-title') || {}).textContent; m = m && m.match(/(\d+)/); q = m ? parseInt(m[1], 10) : 1; }
      cents = cents * q;
    }
    return cents;
  }
  function subPrice() {
    var p = box && box.querySelector('.subscription-radio .rc-radio__price');
    return p ? parseMoney(p.textContent) : null;
  }
  // Static card totals follow the selected size; same rounding as Kaching (% per jar, floored to the cent)
  function staticTotal(i) {
    var r = scRadio(i);
    if (!r || !currentVariant) return null;
    if (r.hasAttribute('data-fixed')) return parseInt(r.dataset.total, 10);
    var u = currentVariant.price, pct = parseFloat(r.dataset.pct) || 0;
    return (u - Math.floor(u * pct / 100)) * (parseInt(r.dataset.qty, 10) || 1);
  }
  // Subscribe while Recharge isn't in the form yet: Shopify's selling_plan field, kept in the form itself (several store
  // scripts intercept the Add to cart click and send the form's fields, so adding it at submit time is too late).
  // As soon as Recharge has its own field ours goes; if Recharge reuses ours, ours just follows the pick.
  function syncPlanField() {
    if (!form || !scRc) return;
    var ours = form.querySelector('input[data-v2-plan]');
    var others = Array.prototype.filter.call(form.querySelectorAll('[name="selling_plan"]'), function (i) { return i !== ours; });
    if (others.length) { if (ours) ours.remove(); return; }
    if (!ours) { ours = document.createElement('input'); ours.type = 'hidden'; ours.name = 'selling_plan'; ours.setAttribute('data-v2-plan', ''); form.appendChild(ours); }
    var sel = (rcReady() && box.querySelector('.rc-selling-plans select')) || scRc.querySelector('[data-v2-sc-plan]');
    var v = mode === 'sub' && sel ? sel.value : '';
    if (ours.value !== v) ours.value = v;
  }
  function syncStatic() {
    if (!hasStatic) return;
    var b = curBar();
    scRadios().forEach(function (r) {
      var on = mode === 'sub' ? r.dataset.v2Pick === 'sub' : (mode === 'once' && r.dataset.v2Pick === 'once' && parseInt(r.dataset.bar, 10) === b);
      if (r.checked !== on) r.checked = on;
    });
    var sp = scRc && scRc.querySelector('[data-v2-sc-subprice]');
    if (sp && currentVariant && currentVariant.sub != null) { var t = money(currentVariant.sub); if (sp.textContent !== t) sp.textContent = t; }
  }

  function enhance() {
    if (!box) return;
    // Recharge: tag + extra line our section owns (Recharge can't output them)
    var l = rcSubLabel();
    if (l) {
      if (box.dataset.subTag && !l.querySelector('.v2-rc-tag')) { var t = document.createElement('span'); t.className = 'v2-rc-tag'; t.textContent = box.dataset.subTag; l.appendChild(t); }
      var lab = l.querySelector('.rc-radio__label');
      if (lab && box.dataset.subNote && !lab.querySelector('.v2-rc-note')) { var n = document.createElement('span'); n.className = 'v2-rc-note'; n.textContent = box.dataset.subNote; lab.appendChild(n); }
    }
    // Bundle: Recharge's one-time row shows the price before the automatic bundle saving → "Save N%" tag + the bundle price
    var one = root.dataset.v2BundleOnce && rcOneLabel(), ol = one && one.querySelector('.rc-radio__label');
    if (ol && !ol.querySelector('.v2-rc-bundle')) {
      ol.textContent = 'One-time purchase ';
      if (root.dataset.v2BundlePct) { var st = document.createElement('span'); st.className = 'v2-rc-save'; st.textContent = 'Save ' + root.dataset.v2BundlePct + '%'; ol.appendChild(st); }
      var bp = document.createElement('span'); bp.className = 'v2-rc-bundle';
      bp.innerHTML = '<s></s> <b></b>';
      bp.querySelector('s').textContent = money(+root.dataset.v2BundleSum); bp.querySelector('b').textContent = money(+root.dataset.v2BundleOnce);
      ol.appendChild(bp);
    }
    // Bundle: free component(s) under both options, on their own line below the title/price line (Oct 22; data from pdp-v2-main)
    if (root.dataset.v2BundleFree) [rcOneLabel(), rcSubLabel()].forEach(function (opt) {
      if (!opt || opt.querySelector('.v2-rc-free')) return;
      root.dataset.v2BundleFree.split('^').forEach(function (it) {
        var f = it.split('|'), line = document.createElement('span');
        line.className = 'v2-rc-free';
        line.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" aria-hidden="true" focusable="false"><path fill="currentColor" d="M20 7h-2.2A3 3 0 0 0 12 3.8 3 3 0 0 0 6.2 7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8h.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm-5-1.5a1.5 1.5 0 0 1 0 3h-2v-1A2 2 0 0 1 15 5.5ZM9 5.5a2 2 0 0 1 2 2v1H9a1.5 1.5 0 0 1 0-3ZM5 9h6v1.5H5Zm1.5 3.5H11V19H6.5Zm11 6.5H13v-6.5h4.5Zm1.5-8.5h-6V9h6Z"/></svg><span></span>';
        line.lastChild.textContent = '+ FREE ' + f[0] + (+f[1] > 0 ? ' · ' : '');
        if (+f[1] > 0) { var v = document.createElement('span'); v.className = 'v2-rc-free-val'; v.textContent = money(+f[1]) + ' value'; line.lastChild.appendChild(v); }   // "$X value" never splits
        var note = opt.querySelector('.v2-rc-note');
        // subscribe: straight under the title/price row, above the plan note
        if (note && note.parentNode) note.parentNode.insertBefore(line, note); else (opt.querySelector('.rc-radio__label') || opt).insertAdjacentElement('afterend', line);
      });
    });
    // Bundle: the closing CTA link shows the listing price (server-side) → the one-time bundle price
    var cta = root.dataset.v2BundleOnce && document.querySelector('.v2-cta-final');
    if (cta && !cta.hasAttribute('data-v2-bundle-price')) { cta.setAttribute('data-v2-bundle-price', ''); cta.textContent = cta.textContent.replace(/\$[\d,.]+\s*$/, money(+root.dataset.v2BundleOnce)); }
    // Kaching: cards aren't keyboard-selectable (its radios are display:none) → make the visible tile a radio
    var bars = kBars();
    var group = box.querySelector('.kaching-bundles__bars');
    if (group && !group.hasAttribute('role')) { group.setAttribute('role', 'radiogroup'); group.setAttribute('aria-label', 'Pack size'); }
    bars.forEach(function (bar) {
      var tile = bar.querySelector('.kaching-bundles__bar-wrapper') || bar;
      if (!tile.hasAttribute('tabindex')) {
        tile.setAttribute('tabindex', '0'); tile.setAttribute('role', 'radio');
        tile.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          (bar.querySelector('label') || bar).click();
        });
      }
      tile.setAttribute('aria-checked', mode === 'once' && bar.classList.contains('kaching-bundles__bar--selected') ? 'true' : 'false');
    });
  }

  function render() {
    var price = null, label = currentVariant ? currentVariant.title : '';
    if (box) {
      box.dataset.mode = mode;
      if (mode === 'sub') {
        if (isLive('rc')) { price = subPrice(); label = (box.querySelector('.rc-radio__subscription') || {}).textContent || 'Subscribe & Save'; }
        else { price = currentVariant && currentVariant.sub; label = (box.querySelector('.v2-sc-sub-name') || {}).textContent || 'Subscribe & Save'; }
      } else if (mode === 'once') {
        if (isLive('k')) {
          var sel = kSelected(); price = barTotal(sel);
          var tt = sel && sel.querySelector('.kaching-bundles__bar-title');
          label = tt ? tt.textContent.trim() + ' · one-time' : 'One-time';
        } else {
          price = staticTotal(bar);
          var r = scRadio(bar), st = r && r.closest('label').querySelector('.v2-sc-title, .v2-sc-set-name');
          label = st ? st.textContent.trim() + ' · one-time' : 'One-time';
        }
      }
      if (onceTotal) { var ot = (mode === 'once' && price != null) ? money(price) : ''; if (onceTotal.textContent !== ot) onceTotal.textContent = ot; }
    }
    if (price == null && currentVariant) price = currentVariant.price;
    // Bundle (product.v2-bundle): one-time price after the automatic bundle saving, worked out by pdp-v2-main
    if (mode !== 'sub' && root.dataset.v2BundleOnce) price = +root.dataset.v2BundleOnce;
    var available = currentVariant ? currentVariant.available : true;
    Array.prototype.forEach.call(soldOutEls, function (el) { el.classList.toggle('is-sold-out', !available); });
    // A pack/set picked from the static cards needs Kaching's discount: until Kaching is ready the button is disabled
    // (a disabled button fires no click, so none of the store's add-to-cart scripts can add a full-price jar instead).
    var waitK = !!box && mode === 'once' && curBar() > 0 && !isLive('k') && !kReady();
    if (atc && hasStatic) {
      var off = !available || waitK;
      if (atc.disabled !== off) atc.disabled = off;
      atc.toggleAttribute('aria-busy', waitK);
    }
    if (atcLabel) { var al = !available ? 'Sold out' : waitK ? 'Loading pack deals…' : 'Add to cart — ' + money(price); if (atcLabel.textContent !== al) atcLabel.textContent = al; }
    syncPlanField();
    var sp = page.querySelector('[data-v2-sticky-price]'), sm = page.querySelector('[data-v2-sticky-mode]');
    if (sp) sp.textContent = money(price);
    if (sm) sm.textContent = String(label).replace(/\s+/g, ' ').trim();
    syncStatic();
    fixSubtitles();
    enhance();
  }

  /* ---------- static cards → live widgets ---------- */
  var waitSince = 0;
  function tick() {
    if (!hasStatic) return;
    var rcNow = !!scRc && !isLive('rc') && rcReady();
    var kNow = !!scK && !isLive('k') && kReady();
    if (rcNow) syncRc();
    if (kNow) syncK();
    var rcDone = !scRc || isLive('rc') || rcNow, kDone = !scK || isLive('k') || kNow;
    if (!(rcNow || kNow) || (!timedOut && !(rcDone && kDone))) return;
    // wait (briefly) until the apps show the pick, so the frame after the swap looks like the frame before it
    if (!appsMatch(rcNow, kNow)) {
      if (!waitSince) waitSince = Date.now();
      if (Date.now() - waitSince < 1500) { setTimeout(tick, 60); return; }
    }
    waitSince = 0;
    swap(rcNow, kNow);
  }
  function swap(rc, k) {
    var focused = document.activeElement, fromStatic = focused && focused.closest && focused.closest('[data-v2-static]');
    var h0 = box.offsetHeight;
    if (rc) box.classList.add('v2-live-rc');
    if (k) { box.classList.add('v2-live-k'); box.classList.remove('v2-k-down'); }
    announceDefault();
    render();
    window.__v2swap.push({ t: Math.round(performance.now()), rc: rc, k: k, h0: h0, h1: box.offsetHeight, timedOut: timedOut });
    if (fromStatic) {   // keep keyboard focus on the same choice
      var to = mode === 'sub' ? (rcSubLabel() && rcSubLabel().querySelector('input'))
        : ((kSelected() || {}).querySelector ? kSelected().querySelector('.kaching-bundles__bar-wrapper') : null);
      if (to) to.focus({ preventScroll: true });
    }
  }
  function onTimeout() {
    timedOut = true;
    if (scK && !isLive('k') && !kReady()) {
      // Kaching missing: packs can't get their discount → disable them; Single + Subscribe keep working
      box.classList.add('v2-k-down');
      scRadios().forEach(function (r) { if (parseInt(r.dataset.bar, 10) > 0) r.disabled = true; });
      if (mode === 'once' && bar > 0) {   // they had picked a pack: fall back to a single jar and say so
        bar = 0; render();
        var msg = box.querySelector('[data-v2-sc-msg]');
        if (msg) { msg.textContent = 'Pack deals didn\u2019t load, so we\u2019ve picked a single jar. Refresh the page to try the packs again.'; msg.hidden = false; }
      }
    }
    tick();
  }
  function enablePacks() {
    box.classList.remove('v2-k-down');
    scRadios().forEach(function (r) { r.disabled = false; });
  }

  if (box) {
    if (hasStatic) {
      var checked = scRadios().filter(function (r) { return r.checked; })[0];
      if (checked && checked.dataset.v2Pick === 'once') bar = parseInt(checked.dataset.bar, 10) || 0;
      scRadios().forEach(function (r) { r.disabled = false; });   // packs are rendered disabled for no-JS
      setTimeout(onTimeout, Math.max(0, APP_TIMEOUT - performance.now()));
    }
    // Shopper clicks: decide the mode from WHAT they clicked (our own programmatic clicks are ignored).
    // Capture phase: Kaching swallows the click on a card it already has selected (in Subscribe mode that's Single,
    // which we keep selected behind the scenes), so a bubbling listener never saw it and Single did nothing.
    // Apps not live yet are invisible and can't be clicked by the shopper, so clicks inside them are the apps' own
    // start-up (Recharge clicks its default option) and must not change the pick.
    box.addEventListener('click', function (e) {
      if (internal) return;
      if (e.target.closest('.rc-radio.subscription-radio')) { if (isLive('rc')) setTimeout(selectSub, 0); return; }
      if (e.target.closest('.kaching-bundles__bar')) { if (isLive('k')) setTimeout(selectOnce, 0); }
      // Bundles (no Kaching): Recharge's own one-time option is shown and is the one-time pick
      if (root.hasAttribute('data-v2-bundle') && e.target.closest('.rc-radio.onetime-radio')) { if (isLive('rc')) setTimeout(selectOnce, 0); }
    }, true);
    box.addEventListener('change', function (e) {
      var r = e.target.closest && e.target.closest('.v2-sc-radio');
      if (r) {   // static card picked: remember it and hand it to any app that's already there
        mode = r.dataset.v2Pick;
        if (mode === 'once') bar = parseInt(r.dataset.bar, 10) || 0;
        var msg = box.querySelector('[data-v2-sc-msg]'); if (msg) msg.hidden = true;
        syncRc(); if (kBars().length && (isLive('k') || kReady())) syncK();
        render(); tick();
        return;
      }
      if (e.target.closest && e.target.closest('[data-v2-sc-plan]')) { syncRc(); render(); return; }
      if (!internal) setTimeout(render, 0);
    });

    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () {
        pending = null;
        var hasRc = !!rcSubLabel(), hasK = kBars().length > 0;
        if (!defaultApplied && (hasRc || hasK)) {
          // No static cards: wait (briefly) for both apps before applying the default pick
          if ((hasRc && hasK) || Date.now() - started > 4000) {
            defaultApplied = true;
            if (hasRc && box.dataset.default === 'subscribe') selectSub();
            else if (hasK) selectOnce();
            else mode = rcIsSub() ? 'sub' : 'once';
          }
        }
        if (mode === 'sub' && isLive('rc') && hasRc && !rcIsSub() && !internal) mode = 'once';   // e.g. Recharge re-rendered on variant change
        if (hasK && scK && !isLive('k') && box.classList.contains('v2-k-down') && kReady()) enablePacks();
        render();
        tick();
      }, 60);
    });
    var started = Date.now();
    mo.observe(box, { subtree: true, childList: true, attributes: true, attributeFilter: ['class'] });
    // Subscribe-mode correction runs synchronously: MutationObserver callbacks run before the next paint, so the
    // stacked % Kaching renders on a size switch (e.g. "Save 24%") is rewritten before it is ever drawn.
    // (Our own rewrite triggers one more callback, which finds nothing left to change.)
    // Same for Recharge: it re-renders its card (dropping our tag + extra line) when its state changes; enhance()
    // puts them back before that frame is painted, so the card never flickers 22px shorter.
    new MutationObserver(function () { syncSetGift(); enhance(); if (mode === 'sub') fixSubtitles(); })
      .observe(box, { subtree: true, childList: true, characterData: true });
    syncSetGift();
    if (!hasStatic) setTimeout(function () { mo.takeRecords(); if (!defaultApplied) { defaultApplied = true; if (rcSubLabel() && box.dataset.default === 'subscribe') selectSub(); else if (kBars().length) selectOnce(); render(); } }, 4500);
    // the Kaching skin loads non-blocking; when it lands, re-check readiness
    var kcss = document.querySelector('link[href*="pdp-v2-kaching"]');
    if (kcss) kcss.addEventListener('load', function () { setTimeout(function () { render(); tick(); }, 0); });
    var rccss = box.querySelector('link[data-v2-rc-css]');
    if (rccss) rccss.addEventListener('load', function () { setTimeout(tick, 0); });

    var pageDeal = dealFromPage();
    if (pageDeal) useDeal(pageDeal);
    else if (window.kachingBundlesApi && window.kachingBundlesApi.fetchDeals) loadDeals();
    else window.addEventListener('load', function () { setTimeout(loadDeals, 500); });

  }
  // Kaching prints this product's deal into the page (script.kaching-bundles-deal-block-settings), so the
  // discounts are known straight away; fetchDeals() is the fallback.
  function dealFromPage() {
    var s = box && box.querySelector('script.kaching-bundles-deal-block-settings');
    if (!s) return null;
    try {
      var j = JSON.parse(s.textContent);
      if (!j || !Array.isArray(j.dealBars)) return null;
      return j.dealBars.map(function (b) {
        return {
          dealBarType: b.dealBarType, quantity: b.quantity,
          discount: b.discountType ? { type: b.discountType, value: b.discountValue } : null,
          bundleProducts: (b.bundleProducts || []).map(function (p) { return { quantity: p.quantity, discount: { type: p.discountType, value: p.discountValue } }; })
        };
      });
    } catch (e) { return null; }
  }
  function useDeal(bars) {
    dealBars = bars;
    dealQty = bars.map(function (b) { return parseInt(b.quantity, 10) || null; });
    fixSubtitles();
    box.setAttribute('data-v2-deals', '');   // CSS shows the save labels/set prices in Subscribe mode from here on
    checkStatic();
    render(); tick();
  }
  // The static cards' numbers come from theme settings / PDP extras; warn when they no longer match the Kaching deal
  function checkStatic() {
    if (!scK || !dealBars) return;
    var issues = [];
    scK.querySelectorAll('.v2-sc-radio[data-bar]').forEach(function (r) {
      var i = parseInt(r.dataset.bar, 10), b = dealBars[i];
      if (!b) { issues.push('card ' + i + ' has no Kaching bar'); return; }
      if (r.hasAttribute('data-fixed')) {
        var items = b.bundleProducts || [], want = parseFloat(scK.dataset.setPct);
        if (b.dealBarType !== 'bundle') issues.push('card ' + i + ' is a set, Kaching bar is ' + b.dealBarType);
        if (String(items.length) !== scK.dataset.setItems) issues.push('set has ' + scK.dataset.setItems + ' items, Kaching ' + items.length);
        items.forEach(function (p) { if (!p.discount || p.discount.value !== want) issues.push('set item % ' + want + ' vs Kaching ' + (p.discount && p.discount.value)); });
      } else {
        var pct = b.discount && b.discount.type === 'percentage' ? b.discount.value : 0;
        if (String(b.quantity) !== r.dataset.qty) issues.push('card ' + i + ' qty ' + r.dataset.qty + ' vs Kaching ' + b.quantity);
        if (pct !== parseFloat(r.dataset.pct)) issues.push('card ' + i + ' ' + r.dataset.pct + '% vs Kaching ' + pct + '%');
      }
    });
    if (issues.length) { box.dataset.v2Mismatch = issues.join('; '); console.warn('[pdp-v2] static offer cards differ from the Kaching deal: ' + issues.join('; ')); }
  }
  // fetchDeals() returns EVERY deal in the store; pick the one rendered here via the deal id Kaching writes
  // into the form (properties[__kaching_bundles] = {"deal":"67kU",...}).
  function currentDealId() {
    var inp = form && form.querySelector('[name="properties[__kaching_bundles]"]');
    if (!inp) return null;
    try { return JSON.parse(inp.value).deal || null; } catch (e) { var m = inp.value.match(/"deal":"([^"]+)"/); return m ? m[1] : null; }
  }
  function loadDeals(attempt) {
    attempt = attempt || 0;
    try {
      var api = window.kachingBundlesApi; if (!api || !api.fetchDeals) return;
      var id = currentDealId();
      if (!id) { if (attempt < 10) setTimeout(function () { loadDeals(attempt + 1); }, 500); return; }
      Promise.resolve(api.fetchDeals()).then(function (d) {
        var list = Array.isArray(d) ? d : (d && (d.deals || Object.values(d))) || [];
        var deal = list.find(function (x) { return x && x.nanoId === id; });
        if (!deal || !deal.dealBars) return;
        useDeal(deal.dealBars);
      }).catch(function () {});
    } catch (e) {}
  }

  // While Subscribe is selected Kaching re-prices the packs from the subscription price, so its "Save X%"
  // subtitles show the stacked number (e.g. 23% instead of 15%). Packs are always one-time here, so show the
  // deal's own one-time discount instead. Kaching rewrites the text itself once a pack is picked.
  // The set card shows its price too, so it also gets its one-time prices back (Kaching's rounding: the
  // discount is floored to the cent, e.g. $27.99 at 20% off → $22.40).
  function fixSubtitles() {
    if (mode !== 'sub' || !dealBars) return;
    kBars().forEach(function (bar, i) {
      var b = dealBars[i], sub = bar.querySelector('.kaching-bundles__bar-subtitle');
      if (!b || !sub) return;
      var pct = b.discount && b.discount.type === 'percentage' ? b.discount.value : null;
      if (b.dealBarType === 'bundle') pct = fixSetPrices(bar, b.bundleProducts || []);
      if (pct == null) return;
      var want = sub.textContent.replace(/Save\s+\d+(\.\d+)?%/i, 'Save ' + pct + '%');
      if (want !== sub.textContent) setText(sub, want);
    });
  }
  function fixSetPrices(bar, items) {
    var els = bar.querySelectorAll('.kaching-bundles__bundle-products__product');
    if (!els.length || els.length !== items.length) return null;
    var total = 0, full = 0;
    for (var i = 0; i < els.length; i++) {
      var d = items[i].discount, q = items[i].quantity || 1;
      var fEl = els[i].querySelector('.kaching-bundles__bundle-products__full-price'), pEl = els[i].querySelector('.kaching-bundles__bundle-products__price');
      var f = fEl && parseMoney(fEl.textContent);
      if (!d || d.type !== 'percentage' || f == null || !pEl) return null;
      var p = f - Math.floor(f * d.value / 100);
      setText(pEl, money(p));
      total += p * q; full += f * q;
    }
    var priceEl = bar.querySelector('.kaching-bundles__bar-price');
    if (priceEl) setText(priceEl, money(total));
    return Math.round((full - total) / full * 100);
  }
  // Set card: show its free gift as a 4th thumbnail ("+" then the gift tile) and name it in the
  // "+ Free …" line. Everything comes from Kaching's own gift element (image + gift text), so the tile only
  // exists while Kaching renders the gift, i.e. while it will actually be added to the cart. No gift element →
  // no tile, and the "+ Free Gift" highlight is hidden so the line reads "Save X%" only.
  // Idempotent: runs from the synchronous observer (before paint) and only writes when something differs.
  var GIFT_SVG = '<svg viewBox="0 0 24 24" width="11" height="11" aria-hidden="true" focusable="false"><path fill="currentColor" d="M20 7h-2.2A3 3 0 0 0 12 3.8 3 3 0 0 0 6.2 7H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h.5v8a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-8h.5a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1Zm-5-1.5a1.5 1.5 0 0 1 0 3h-2v-1A2 2 0 0 1 15 5.5ZM9 5.5a2 2 0 0 1 2 2v1H9a1.5 1.5 0 0 1 0-3ZM5 9h6v1.5H5Zm1.5 3.5H11V19H6.5Zm11 6.5H13v-6.5h4.5Zm1.5-8.5h-6V9h6Z"/></svg>';
  function giftName(text) {
    var t = (text || '').replace(/\s+/g, ' ').trim()
      .replace(/^\+?\s*free\s+/i, '').replace(/\s+(added|included)\b.*$/i, '').replace(/[!.]+$/, '')
      .replace(/\b\d+(\.\d+)?\s?(fl oz|oz|ml)\b/ig, '').replace(/\s+/g, ' ').trim();
    if (!t || /^(a\s+)?gift$/i.test(t)) return 'Gift';
    var words = t.split(' ').map(function (w) { return w.charAt(0).toUpperCase() + w.slice(1); });
    while (words.length > 1 && words.join(' ').length > 24) words.pop();   // shorten long names at a word break
    return words.join(' ');
  }
  function syncSetGift() {
    if (!box) return;
    kBars().forEach(function (bar) {
      var list = bar.querySelector('.kaching-bundles__bundle-products');
      if (!list) return;
      var gift = bar.querySelector('.kaching-bundles__free-gift');
      var img = gift && !gift.hidden && gift.querySelector('img.kaching-bundles__free-gift__image');
      var src = img && img.getAttribute('src');
      var hlText = bar.querySelector('.kaching-bundles__highlights__text');
      var hl = hlText && hlText.closest('.kaching-bundles__highlights');
      var plus = list.querySelector('.v2-gift-plus'), tile = list.querySelector('.v2-gift-tile');
      if (!src) {
        if (plus) plus.remove();
        if (tile) tile.remove();
        if (hl && !hl.hidden) hl.hidden = true;
        return;
      }
      var gText = gift.querySelector('.kaching-bundles__free-gift__text');
      var name = giftName(gText && gText.textContent);
      var full = src.replace(/([?&]height=)\d*/, '$1200');
      if (!tile) {
        plus = document.createElement('div'); plus.className = 'v2-gift-plus'; plus.setAttribute('aria-hidden', 'true'); plus.textContent = '+';
        tile = document.createElement('div'); tile.className = 'v2-gift-tile';
        tile.innerHTML = '<span class="v2-gift-img"><img width="56" height="56" loading="lazy"><span class="v2-gift-badge">' + GIFT_SVG + '</span></span><span class="v2-gift-free">FREE</span>';
      }
      if (list.lastElementChild !== tile || tile.previousElementSibling !== plus) { list.appendChild(plus); list.appendChild(tile); }
      var timg = tile.querySelector('img');
      if (timg.getAttribute('src') !== full) timg.setAttribute('src', full);
      if (timg.alt !== 'Free gift: ' + name) timg.alt = 'Free gift: ' + name;
      if (hl && hl.hidden) hl.hidden = false;
      if (hlText) setText(hlText, '+ Free ' + name);
    });
  }
  // Replace only the first text node so Kaching's own render markers (<!---->) survive
  function setText(el, s) {
    var t = Array.prototype.find.call(el.childNodes, function (n) { return n.nodeType === 3 && n.textContent.trim(); });
    if (t) { if (t.textContent !== s) t.textContent = s; } else if (el.textContent !== s) el.textContent = s;
  }

  /* ---------- sticky mobile ATC ---------- */
  var sticky = page.querySelector('[data-v2-sticky-atc]');
  if (sticky && atc) {
    var stickyBtn = sticky.querySelector('[data-v2-sticky-btn]');
    var ticking = false, shown = null;
    var checkSticky = function () {
      ticking = false;
      var visible = atc.getBoundingClientRect().bottom < 0;   // main button scrolled above the viewport
      if (visible === shown) return;
      shown = visible;
      sticky.classList.toggle('is-visible', visible);
      sticky.setAttribute('aria-hidden', String(!visible));
      if (stickyBtn) stickyBtn.tabIndex = visible ? 0 : -1;
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(checkSticky); } }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
    if (stickyBtn) stickyBtn.addEventListener('click', function () { atc.click(); });
  }

  render();
})();
